<div class="backdrop"></div>
<div class="loading-spinner">
  <div class="la-ball-clip-rotate-multiple">
    <div></div>
    <div></div>
  </div>
</div>